
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { KycOrgConfig } from '@/api/auth';
import { KycRequests } from '@/api';
import ApiCancelError from '@/resources/error/ApiCancelError';
import ApiModalError from '@/resources/error/ApiModalError';
import { setTimeoutAsync } from '@/services/utils';
import { LoadingLimitMilliSecond } from '@/resources/application';
import { sha256 } from '@/util/crypt';

@Component
export default class Screen extends Vue {
  private intervalId: number = -1;
  private intervalCount: number = 0;
  private image: string =
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAIAAAA7ljmRAAAADklEQVR4AWP4/x+BcHMA3lYX6fnafbAAAAAASUVORK5CYII=';

  async mounted() {
    // ローディング中の見た目の変更
    this.intervalId = window.setInterval((): void => {
      this.intervalCount++;
    }, 600);

    try {
      // 認証通信
      this.$store.commit('auth/clearOrgNames');
      await Promise.all([this.$store.dispatch('auth/storeAuth'), setTimeoutAsync(LoadingLimitMilliSecond)]);
      this.$store.dispatch('style/setApplicantCustomStyles', this.$store.getters['auth/applicantCustomStyles']);
      if (this.$store.getters['auth/isPaidy']) this.$store.dispatch('style/setPaidyStyle');
      this.$store.commit('terms/storeAgreedTermsOfService', this.$store.getters['auth/kycOrgConfigAgreedTermsOfService']); // eslint-disable-line prettier/prettier

      // AccesssTokenを取得できている場合（生年月日認証がない場合）ClientTypeを送信
      const accessToken: string = this.$store.getters['auth/accessToken'];
      if (accessToken) {
        const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
        const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];
        const isFetchClientTypes: boolean = kycOrgConfig.enableClientTypePC;
        if (isFetchClientTypes) await KycRequests.fetchClientTypes(kycRequestId, this.$store.getters['camera/isPC']);
      }

      const applicantID: number = this.$store.getters['auth/applicantId'];
      if (this.$gtag && applicantID && applicantID > 0) {
        // GAのUserID情報として今後のログに自動追加する設定を実施
        const userID: string = await sha256(`${applicantID}`);
        this.$gtag.set({ user_id: userID });
      }

      this.sendAuthRequestLogForGA();

      // serverからdefaultLanguageの指定がある場合は設定
      if (this.$store.getters['auth/defaultLanguage'] !== '') {
        this.$store.dispatch('i18n/setLocaleWithi18nWithoutDefaultLocale', {
          locale: this.$store.getters['auth/defaultLanguage']
        });
      }

      // ワクチン接種証明特別対応
      if (this.$store.getters['auth/isPassVaccine']) {
        this.$store.dispatch('i18n/setLocaleWithi18n', { locale: 'ja' });
        this.$router.replace({ name: 'pass-vaccine-introduction' });
        return;
      }

      // 注意喚起画面をONにしている
      if (this.$store.getters['auth/showScamAlert']) {
        this.$router.replace({ name: 'scam-alert' });
        return;
      }

      // 生年月日認証をONにしている
      if (this.$store.getters['auth/kycOrgConfigBirthAuth']) {
        this.$router.replace({ name: 'birthday' });
        return;
      }

      // 利用規約同意済み
      const checkTermsOfService: KycOrgConfig = this.$store.getters['auth/kycOrgConfigCheckTermsOfService'];
      const agreedTermsOfService: boolean = this.$store.getters['terms/agreedTermsOfService'];
      if (!checkTermsOfService || agreedTermsOfService) {
        this.$router.replace('/top/personal-information');
        return;
      }

      this.$router.replace({ name: 'terms' });
    } catch (error) {
      if (error instanceof ApiCancelError) {
        // キャンセルは握りつぶす
      } else if (error instanceof ApiModalError) {
        // clientRetryableで処理したエラーは握りつぶす
      } else throw error;

      // this.$buefy.toast.open({
      //   type: 'is-warning',
      //   message: '認証に失敗しました'
      // });
    }
  }

  beforeDestroy(): void {
    this.intervalId && window.clearInterval(this.intervalId);
  }

  sendAuthRequestLogForGA(): void {
    if (!this.$gtag) return;
    try {
      const sendDateTimeKey: string = moment.utc().tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss');
      const kycOrgConfig: KycOrgConfig = this.$store.getters['auth/kycOrgConfig'];
      const kycOrgID: number = kycOrgConfig.id;
      const kycRequestId: number = this.$store.getters['auth/kycRequestID'];
      const requestTimes: number = this.$store.getters['auth/requestTimes'];

      this.$gtag.event('request_auth_api', {
        send_datetime: sendDateTimeKey,
        kyc_org_id: kycOrgID,
        kyc_request_id: kycRequestId,
        request_times: requestTimes
      });
    } catch (_) {
    } finally {
      return;
    }
  }
}
